import React from 'react';
import { Skeleton, Table } from 'antd';
const { Column } = Table;

const data = [
  {
    key: '1',
    Issuer: '10 ONT 61<br/>03/29',
    Series: '10/30/25',
    Type: "Corp",
    CPN: '7%',
    Price: '$104.65',
    Bid: '$105.05',
    Ask: '$106.05',
  },
  {
    key: '2',
    Issuer: '10 ONT 61<br/>03/29',
    Series: '10/30/25',
    Type: "Corp",
    CPN: '7%',
    Price: '$104.65',
    Bid: '$105.05',
    Ask: '$106.05',
  },
  {
    key: '3',
    Issuer: '10 ONT 61<br/>03/29',
    Series: '10/30/25',
    Type: "Corp",
    CPN: '7%',
    Price: '$104.65',
    Bid: '$105.05',
    Ask: '$106.05',
  },
];

const Tables = ({bonds}) => {
  return (
    <div>
      {bonds?.length ? 
      <Table dataSource={bonds}>
        <Column title="Issuer" dataIndex="Issuer" key="Issuer" render={(text) => <span dangerouslySetInnerHTML={{ __html: text }} />} />
        <Column title="Series" dataIndex="Series" key="Series" />
        <Column title="Type" dataIndex="Type" key="Type" />
        <Column title="CPN" dataIndex="CPN" key="CPN" />
        <Column title="Price" dataIndex="Price" key="Price" />
        <Column title="Bid" dataIndex="Bid" key="Bid" />
        <Column title="Ask" dataIndex="Ask" key="Ask" />
        <Column title="Curr" />
      </Table>
      :
        <Skeleton />
}
    </div>
  )
};

export default Tables;
